import { HttpStatusCode } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';

import { AppError, ErrorsInterceptor } from '@hglobal/fin-ui';

import { VpnCheckDialogComponent } from '@iw/common';
import { RouterStore } from '@iw/store';

import { AuthService } from '../../auth-store';
import { IwDialogService } from '../../services';

/**
 * App Errors interceptor
 */
@Injectable()
export class AppErrorsInterceptor extends ErrorsInterceptor {
  readonly #injector = inject(Injector);
  readonly #routerStore = inject(RouterStore);
  readonly #dialogService = inject(IwDialogService);

  #vpnDialogShown = false;
  override codeField = 'errorCode';
  override messageField = 'errorDescription';
  override dataField = 'data';

  override beforeThrowing(error: AppError): AppError {
    if (error.originalError?.status === HttpStatusCode.Unauthorized) {
      const currentPath = window.location.pathname;
      const isTfaRoute = currentPath.includes('/signin/tfa');

      if (!isTfaRoute) {
        this.#getAuthService().clearAuthState();
      }
    }

    if (error.originalError?.status === HttpStatusCode.NotFound) {
      this.#routerStore.navigateTo404();
    }

    if (error.originalError?.status === HttpStatusCode.Forbidden) {
      const url = error.originalError?.url || '';

      if (url.includes('/backoffice/')) {
        this.#showVpnCheckDialog();
      }
    }

    return error;
  }

  /** Lazy-loaded AuthService to avoid circular dependency */
  #getAuthService(): AuthService {
    return this.#injector.get(AuthService);
  }

  #showVpnCheckDialog(): void {
    if (this.#vpnDialogShown) {
      return;
    }

    this.#vpnDialogShown = true;

    const dialogRef = this.#dialogService.open<VpnCheckDialogComponent, void>({
      components: [VpnCheckDialogComponent],
      isOnTop: true,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.#vpnDialogShown = false;
    });
  }
}
